<template>
    <b-modal
        id="edit"
        title="Editar Redação"
        size="lg"
        hide-footer>
        <b-overlay :show="loading" rounded="sm">
            <b-form @submit="submit" @submit.stop.prevent>

                <div class="row">
                    <div class="col-12 col-sm-5">
                        <!-- Field -->
                        <b-form-group
                            label="Turma"
                            description="Qual a turma que o aluno desta redação faz parte ?">
                            <!-- Input -->
                            <multiselect
                                v-model="group"
                                :options="groups"
                                :loading="loadingGroup"
                                track-by="id"
                                label="name"
                                placeholder=""
                                @select="selectGroup"
                                @remove="removeGroup"
                                @search-change="searchGroup"
                                tag-placeholder="Filtrar Turma"
                                selectLabel="Selecionar"
                                deselectLabel="Desmarcar"
                                selectedLabel="Selecionado">

                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>

                                <span slot="noOptions">
                                    Não há turmas disponíveis para exibir :(
                                </span>

                            </multiselect>

                            <!-- Error -->
                            <has-errors :errors="errors" name="group_id" />
                        </b-form-group>
                    </div>
                    <div class="col-12 col-sm-7">
                        <!-- Field -->
                        <b-form-group
                            label="Aluno"
                            description="Qual é o aluno que escreveu essa redação ?">
                            <!-- Input -->
                            <multiselect
                                v-model="student"
                                :options="students"
                                :loading="loadingStudent"
                                track-by="id"
                                label="name"
                                placeholder=""
                                @select="(value) => this.form.student_id = value.id"
                                @remove="() => this.form.student_id = null"
                                @search-change="searchStudent"
                                tag-placeholder="Filtrar Aluno"
                                selectLabel="Selecionar"
                                deselectLabel="Desmarcar"
                                selectedLabel="Selecionado">

                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>

                                <span slot="noOptions">
                                    Não há alunos disponíveis para exibir :(
                                </span>

                            </multiselect>

                            <!-- Error -->
                            <has-errors :errors="errors" name="student_id" />
                        </b-form-group>
                    </div>
                </div>

                <!-- Field -->
                <b-form-group
                    v-show="false"
                    label="Modo de Tema"
                    description="Qual o modo de tema que deseja enviar a redação ? Específico ou Livre ?">
                    <!-- Input -->
                    <b-form-radio v-model="form.type" name="type" value="theme">
                        Quero indicar um tema específico para a redação.
                    </b-form-radio>
                    <b-form-radio v-model="form.type" name="type" value="mode">
                        Quero um tema livre para a redação.
                    </b-form-radio>

                    <!-- Error -->
                    <has-errors :errors="errors" name="type" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    v-show="false"
                    v-if="form.type === 'theme'"
                    label="Tema"
                    description="Qual é o tema da redação ?">
                    <!-- Input -->
                    <multiselect
                        v-model="theme"
                        :options="themes"
                        :loading="loadingTheme"
                        track-by="id"
                        label="title"
                        placeholder=""
                        @select="(value) => this.form.theme_id = value.id"
                        @remove="() => this.form.theme_id = null"
                        @search-change="searchTheme"
                        tag-placeholder="Filtrar Tema"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                        <span slot="noResult">
                            Ops! Nenhum resultado encontrado na pesquisa :(
                        </span>

                        <span slot="noOptions">
                            Não há temas disponíveis para exibir :(
                        </span>

                    </multiselect>

                    <!-- Error -->
                    <has-errors :errors="errors" name="theme_id" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    v-show="false"
                    v-if="form.type === 'mode'"
                    label="Modo de Correção"
                    description="Qual é o modo de correção que a redação deve ser corrigida ?">
                    <!-- Input -->
                    <multiselect
                        v-model="mode"
                        :options="modes"
                        :loading="loading"
                        track-by="id"
                        label="name"
                        placeholder=""
                        @select="(value) => this.form.mode_id = value.id"
                        @remove="() => this.form.mode_id = null"
                        tag-placeholder="Filtrar Modo de Correção"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                        <span slot="noResult">
                            Ops! Nenhum resultado encontrado na pesquisa :(
                        </span>

                        <span slot="noOptions">
                            Não há modos de correção disponíveis para exibir :(
                        </span>

                    </multiselect>

                    <!-- Error -->
                    <has-errors :errors="errors" name="mode_id" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Editar Redação
                </b-button>
            </b-form>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['modes'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingStudent: false,
            loadingTheme: false,
            errors: {},
            id: null,
            form: {
                group_id: null,
                student_id: null,
                type: 'theme',
                theme_id: null,
                mode_id: null,
            },
            group: null,
            student: null,
            theme: null,
            mode: null,
            groups: [],
            students: [],
            themes: []
        }
    },
    watch: {
        'form.type': function (type) {
            if (type === 'theme') {
                this.form.mode_id = null;
                this.mode = null;
            }
            if (type === 'mode') {
                this.form.theme_id = null;
                this.theme = null;
            }
        },
    },
    created() {
        this.$root.$on('editEssay', async (essay) => {

            // Clear Elements
            await this.clear()

            // Set Form
            this.id = essay.id
            this.form.group_id = essay.group_id
            this.form.student_id = await essay.student_id
            this.form.theme_id = await essay.theme_id
            this.form.mode_id = await essay.mode_id

            // Set Selects
            this.group = essay.group;
            this.student = essay.student;
            this.theme = essay.theme;
            this.mode = essay.mode;

            // Check Type
            if (this.form.mode_id !== null)
                this.form.type = 'mode'

            // Groups Init Search
            await this.searchGroup(null)

            // Students Init Search
            await this.searchStudent(null)

            // Themes Init Search
            await this.searchTheme(null)

            // Modal
            this.$bvModal.show('edit')
        })
    },
    methods: {

        submit() {
            this.loading = true;
            axios.put('/teacher/essays/' + this.id, this.form)
                .then((result) => {

                    // Close Modal
                    this.$bvModal.hide('edit')

                    // Message
                    this.$toast.success('Redação editada com sucesso !')

                    // Clear Form
                    this.clear()

                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                })
                .finally(() => this.loadingGroup = false)
        },

        searchStudent(text) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.form.group_id,
                    name: text
                }
            })
                .then((result) => {
                    this.students = result.data.data.students;
                })
                .finally(() => this.loadingStudent = false)
        },

        searchTheme(text) {
            this.loadingTheme = true;
            axios.get('/teacher/themes/search', {
                params: {
                    title: text
                }
            })
                .then((result) => {
                    this.themes = result.data.data.themes;
                })
                .finally(() => this.loadingTheme = false)
        },

        selectGroup(value) {
            this.form.group_id = value.id;
            this.form.student_id = null
            this.student = null

            // Load Students
            this.searchStudent(null)
        },

        removeGroup() {
            this.form.group_id = null;
            this.form.student_id = null
            this.student = null
            this.students = []
        },

        clear() {
            this.form = {
                group_id: null,
                student_id: null,
                type: 'theme',
                theme_id: null,
                mode_id: null,
            }

            this.group = null;
            this.student = null;
            this.theme = null;
            this.mode = null;
        }

    }
}
</script>

<style scoped>

</style>
